// Shared token store — bridges useAuth (token owner) and socket-io (token consumer)
// without a circular import. Neither side imports the other through this module.
let _token = null;

export const setAuthToken = (token) => { _token = token; };
export const getAuthToken = () => _token;
